import { render, staticRenderFns } from "./businessInfoWindow.vue?vue&type=template&id=229b82d8&scoped=true"
import script from "./businessInfoWindow.vue?vue&type=script&lang=js"
export * from "./businessInfoWindow.vue?vue&type=script&lang=js"
import style0 from "./businessInfoWindow.vue?vue&type=style&index=0&id=229b82d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229b82d8",
  null
  
)

export default component.exports